import React, { useState, useEffect } from "react";
import { Input, Row, Typography, Form, Divider, Card, Table, Col } from "antd";
import appLabel from "../../../../../config/appLabel";

const { Text, Title } = Typography;

const columnsOne = [
  {
    title: "Payment Type",
    dataIndex: "paymentType",
  },
  {
    title: "Fund Source",
    dataIndex: "fundSource",
  },
];

const columnsTwo = [
  {
    title: "Fees",
    dataIndex: "fees",
  },
  {
    title: "Income Account",
    dataIndex: "incomeAccount",
  },
];

const columnsThree = [
  {
    title: "Penalty",
    dataIndex: "penalty",
  },
  {
    title: "Income Account",
    dataIndex: "incomeAccountPenalty",
  },
];

export const AccountingForm = (props) => {
  const { useForm, loanProductDetails } = props;
  const [accountDetailOne, setAccountDetailOne] = useState([]);
  const [accountDetailTwo, setAccountDetailTwo] = useState([]);
  const [accountDetailThree, setAccountDetailThree] = useState([]);

  useEffect(() => {
    let tempArrayOne = [];
    let tempArrayTwo = [];
    let tempArrayThree = [];
    const fundSourcesforPaymentChannels =
      loanProductDetails?.paymentChannelToFundSourceMappings
        ? loanProductDetails?.paymentChannelToFundSourceMappings
        : ["-"];
    fundSourcesforPaymentChannels.forEach((element) => {
      tempArrayOne.push({
        key: element?.id,
        paymentType: element?.paymentType?.name
          ? element?.paymentType?.name
          : "-",
        fundSource: element?.fundSourceAccount?.name
          ? element?.fundSourceAccount?.name
          : "-",
      });
    });
    const feestoSpecificIncomeAccount =
      loanProductDetails?.feeToIncomeAccountMappings
        ? loanProductDetails?.feeToIncomeAccountMappings
        : ["-"];

    feestoSpecificIncomeAccount.forEach((element) => {
      tempArrayTwo.push({
        key: element?.id,
        fees: element?.charge?.name ? element?.charge?.name : "-",
        incomeAccount: element?.incomeAccount?.name
          ? element?.incomeAccount?.name
          : "-",
      });
    });

    const penaltiestoSpecificIncomeAccount =
      loanProductDetails?.feeToIncomeAccountMappings
        ? loanProductDetails?.feeToIncomeAccountMappings
        : ["-"];
    penaltiestoSpecificIncomeAccount.forEach((element) => {
      tempArrayThree.push({
        key: element?.id,
        penalty: element?.paymentType?.name ? element?.paymentType?.name : "-",
        incomeAccountPenalty: element?.fundSourceAccount?.name
          ? element?.fundSourceAccount?.name
          : "-",
      });
    });
    setAccountDetailOne(tempArrayOne);
    setAccountDetailTwo(tempArrayTwo);
    setAccountDetailThree(tempArrayThree);
  }, []);

  return (
    <Form layout="vertical" form={useForm}>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          padding: 10,
        }}
      >
        <Row>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {"  Assests"}
            </Title>
          </Divider>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text>Fund Source</Text>}
              name="fundSourceAccountId"
            >
              <Input className="of-bold-disable-input" disabled />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text>Loan Portfolio</Text>}
              name="loanPortfolioAccountId"
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  loanProductDetails?.accountingMappings?.loanPortfolioAccount
                    ?.name
                }
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text>Transfer In Suspense</Text>}
              name="transfersInSuspenseAccountId"
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  loanProductDetails?.accountingMappings
                    ?.transfersInSuspenseAccount?.name
                }
              />
            </Form.Item>
          </Col>

          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {"Income"}
            </Title>
          </Divider>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text>Income From Interest</Text>}
              name="interestOnLoanAccountId"
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  loanProductDetails?.accountingMappings?.interestOnLoanAccount
                    ?.name
                }
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text>Income From Fees</Text>}
              name="incomeFromFeeAccountId"
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  loanProductDetails?.accountingMappings?.incomeFromFeeAccount
                    ?.name
                }
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text>Income From Penalties</Text>}
              name="incomeFromPenaltyAccountId"
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  loanProductDetails?.accountingMappings
                    ?.incomeFromPenaltyAccount?.name
                }
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text>Income From Recovery Payments</Text>}
              name="incomeFromRecoveryAccountId"
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  loanProductDetails?.accountingMappings
                    ?.incomeFromRecoveryAccount?.name
                }
              />
            </Form.Item>
          </Col>

          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {"Expenses"}
            </Title>
          </Divider>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text>Losses Written Off</Text>}
              name="writeOffAccountId"
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  loanProductDetails?.accountingMappings?.writeOffAccount?.name
                }
              />
            </Form.Item>
          </Col>

          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {"Liabilities"}
            </Title>
          </Divider>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text>Overpayment Liability</Text>}
              name="overpaymentLiabilityAccountId"
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  loanProductDetails?.accountingMappings
                    ?.overpaymentLiabilityAccount?.name
                }
              ></Input>
            </Form.Item>
          </Col>
        </Row>
        <Title level={4} style={{ margin: 0 }}>
          Advanced Accounting Rule
        </Title>
        <Divider />
        <Table
          columns={columnsOne}
          dataSource={accountDetailOne}
          bordered
          title={(e) => "Configure Fund Sources for Payment Channels"}
          pagination={{
            position: "bottomCentre",
          }}
        />
        <Table
          columns={columnsTwo}
          dataSource={accountDetailTwo}
          bordered
          title={(e) => "Fees to Specific Income Account"}
          pagination={{
            position: "bottomCentre",
          }}
        />
        <Table
          columns={columnsThree}
          dataSource={accountDetailThree}
          bordered
          title={(e) => "Penalties to Specific Income Account"}
          pagination={{
            position: "bottomCentre",
          }}
        />
      </Card>
    </Form>
  );
};
